import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doAdd: { api: 'M1020SubjectService.doAdd'},
    getEdit: { api: 'M1020SubjectService.getEdit'},
    doEdit: { api: 'M1020SubjectService.doEdit'},
    doRead: { api: 'M1020SubjectService.doRead'},
    doDelete: { api: 'M1020SubjectService.doDelete'},
    doBrowse: { api: 'M1020SubjectService.M20401_doBrowse_AtDataTable'},
    getTableColumnDefsDataForSearchTable: { api: 'M1020SubjectService.getTableColumnDefsDataForSearchTable'},
    getTableColumnDefsDataForAtForm: { api: 'M1020SubjectService.getTableColumnDefsDataForAtForm'},
    getSubjectsDropdown: { api: 'M1020SubjectService.getSubjectsDropdown'},
  },
}

const module = {
  state: {
    PageConst,
    inited: false,

    subjectsList: [],
    subjectTypeList: [
      { value: 1, label: '単一科目' },
      { value: 2, label: '複数科目' },
    ],
    valueList: {},

    defaultDoBrowse: {
      searchInfo: {
        search: '',
        delete_flag: 0
      },
      orderBy: {},
      doBrowseStatus: 'init'
    },
  },

  getters: {},

  mutations: {},

  actions: {
    async init ({ state }) {
      const res = await ApiUtils.postData({
        data: {
          valueList: { api: 'T2010TeacherBasicService.C10101_getDropdownData' },
        }
      })
      state.valueList = res.valueList.output
      state.inited = true
    },
    // @deprecated
    async getSubjectsDropdown ({ state }, { studentClassification }) {
      const res = await ApiUtils.postData({
        data: [{
          ...PageConst.ACTION.getSubjectsDropdown,
          input: { student_classification:studentClassification }
        }]
      })
      state.subjectsList = res[0].output;
    },
    async M20401_exportCSV ({ state }) {
      const res = await ApiUtils.postData({
        data: [{
          api: 'M1020SubjectService.M20401_exportCSV',
          input: { searchInfo: state.searchInfo, orderBy: state.orderBy }
        }]
      })
      return res[0].output;
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
